import React from "react";
import CollapsibleContainer from '../components/collapsibleContainer';
import { useSelector, useDispatch } from "react-redux";
import { ACTIONS as DATA_ACTIONS } from "../redux/reducers/DataReducer"
import { IoIosSettings } from "react-icons/io";
import Spinner from "../components/spinner";

import { HeightSlider } from "./twoD";

const Settings = ()=>{
    const settings = useSelector(state=>state.data.data)
    const data = useSelector(state => state.data);
    const dispatch = useDispatch();

    if (data && data.planet && data.planetStore){

        return (
            <CollapsibleContainer open title={data.planet }  icon={<IoIosSettings />}>
                <div>
                <b>Select planet : </b>

                {data.planetStore.planets.map(({name})=><span key={name} onClick={
                    ()=>{
                        dispatch({type: DATA_ACTIONS.SET_PLANET, planet: name})
                    }
                } style={{cursor: "pointer", textDecoration: (name==data.planet)?"underline":"none"}} >{name},&nbsp;</span>)}

                <br/><br/>

                {data.planetStore.data(data.planet).description}

                <br/><br/>
                <b>Select variable : </b>
                {data.planetStore.variables.map((name)=><span key={name} onClick={
                    ()=>{
                        dispatch({type: DATA_ACTIONS.SET_VARIABLE, variable: name})
                    }
                } style={{cursor: "pointer", textDecoration: (name==data.variable)?"underline":"none"}} >{name},&nbsp;</span>)}

                <br/><br/>
                <b>Selected Coordinates : </b> [X: {data.coordinates.x}, Y: {data.coordinates.y}]

                <br/><br/>
                <HeightSlider />
                {/* <b>Selected Height : </b> {data.height} */}
                </div>
                
    
              
            </CollapsibleContainer>
            )
    
    } else {
        return <Spinner />
    }

    
}

export default Settings;